import React, {useState} from "react";
import Modal from "@/layout/Modal";
import {Button} from "@varymadellc/my-weed-club-component-library";
import {FiHelpCircle} from "react-icons/fi";

export interface ShareGiphyBookmarkProps {
}

const giphyBookmarkCode = `
javascript:(function() {
    var embedSpans = document.querySelectorAll('span');
    var embedButton;
    for (var i = 0; i < embedSpans.length; i++) {
        if (embedSpans[i].textContent === 'Embed') {
            embedButton = embedSpans[i].closest('div').querySelector('button');
            break;
        }
    }

    if (embedButton) {
        embedButton.click();

        setTimeout(function() {
            var textArea = document.querySelector('div[class^="EmbedCodeContainer"]');
            if (textArea) {
                var embedCode = textArea.innerText;

                var overlay = document.createElement('div');
                overlay.style.position = 'fixed';
                overlay.style.top = '0';
                overlay.style.left = '0';
                overlay.style.width = '100%';
                overlay.style.height = '100%';
                overlay.style.backgroundColor = 'rgba(0,0,0,0.8)';
                overlay.style.zIndex = '9999';
                overlay.style.display = 'flex';
                overlay.style.justifyContent = 'center';
                overlay.style.alignItems = 'center';
                overlay.style.cursor = 'pointer';
                
                document.body.appendChild(overlay);

                const button = document.createElement('button');
                button.innerText = 'Add to MWC';
                button.onclick = function() {
                    var referringUrl = window.location.href;

                    var jsonData = {
                        "embed": embedCode,
                        "referringUrl": referringUrl,
                        "title": document.title,
                    };

                    var jsonString = JSON.stringify(jsonData);
                    window.open('https://myweed.club/q?giphy=' + encodeURIComponent(jsonString), '_blank');

                    document.body.removeChild(overlay);
                };
                
                overlay.appendChild(button);
                
            }
        }, 1000);
    }
})(); 
`;

export default function ShareGiphyBookmark({}: ShareGiphyBookmarkProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const [clicked, setClicked] = useState<boolean>(false);

    return (
        <>
            <div className="flex flex-row justify-center items-center">
                <a className="bg-primary p-1 rounded !text-black rounded-r-none" onDragStart={() => {
                    setClicked(true);
                }} onDragEnd={() => {
                    setTimeout(() => { setClicked(false); }, 1000);
                }
                } href={giphyBookmarkCode}>{clicked ? "Drag to bookmark" : "Giphy Quick Add Bookmark"}</a>
                <Button onClick={() => setIsOpen(true)}
                        className="!bg-black text-white text-sm sm:text-base p-2 rounded-l-none">
                    <FiHelpCircle className="inline-block"/>
                </Button>
            </div>
            <Modal onClose={() => setIsOpen(false)} isOpen={isOpen}>
                <div className="flex flex-col gap-2">
                    <p>
                        Drag this button to your bookmark bar to share a Giphy Image with
                        us.
                    </p>
                    <p>
                        To use it, you simply add it or drag it to your bookmarks, then you goto giphy, find the image you want.
                        While on the same page as the image you want to add (on giphy), click on the bookmark you
                        just added to your bar. It&apos;ll open a new tab with MyWeed.Club and the image will be
                        added to the queue.
                    </p>
                    <p>
                        Note, that you must be logged in for the image to be added to the queue.
                        Also please make sure if you click it, that you actually want to share the image, it&apos;ll
                        add it to the queue instantly.
                    </p>
                </div>
            </Modal>
        </>
    );
}